export const getTzFromNumber = (tzNumber: number): string => {
  const sign = tzNumber > 0 ? '+' : '-';
  const hours = Math.abs(tzNumber).toString().padStart(2, '0');

  return `${sign}${hours}:00`;
};
